<div class="jsonata-field">
  <pre class="jsonata-highlight" aria-hidden="true" [innerHTML]="highlighted"></pre>
  <textarea
    class="jsonata-input"
    spellcheck="false"
    [rows]="rows"
    [placeholder]="placeholder"
    [ngModel]="value"
    (ngModelChange)="onInput($event)"
    (scroll)="syncScroll($event)"></textarea>
</div>
